import { useState } from "react";
import { Badge, Dropdown } from "react-bootstrap";
import { useSelector } from "react-redux";
import DeleteModal from "../../../../common/DeleteModal";
import { Translate } from "../../../../Enums/Tranlate";
import editIcon from "../../../../../images/icons/edit.svg";
import trashIcon from "../../../../../images/icons/delete.svg";
import { Link } from "react-router-dom";
import RoleService from "../../../../../services/RoleService";
import { usePermissions } from "../../../../common/permissions";

const CardItem = ({ item, setItem, index, setViewModal, setShouldUpdate }) => {
	const [deleteModal, setDeleteModal] = useState(false);
	const Auth = useSelector((state) => state.auth?.auth);
	const lang = useSelector((state) => state.auth?.lang);
	const { canEdit, canDelete } = usePermissions();
	const roleService = new RoleService();

	const dateStr = item?.createdAt;
	const date = new Date(dateStr);
	date.setHours(date.getHours() + 1);
	// const formattedDate = date.toISOString()?.split("T")[0];

	return (
		<tr key={index} className="text-center">
			<td>{item?.name}</td>
			{/* <td>{formattedDate}</td> */}
			{/* <td>
				<Badge
					className="text-capitalize"
					variant={`${item?.isActive ? "success" : "danger"} light`}>
					{item?.isActive ? Translate[lang].active : Translate[lang].deactive}
				</Badge>
			</td> */}
			<td>
				<div className="d-flex justify-content-center" style={{ gap: "20px" }}>
					<Link
						to={`/roles/${item?.id}`}
						state={item}
						style={{
							color: "#0F50A6",
							fontWeight: "500",
						}}>
						{canEdit("rules") && (
							<img src={editIcon} alt="view" width={24} />
						)}
					</Link>
					{/* <img src={editIcon} className="cursor-pointer" onClick={()=> {
                        setItem(item)
                    }} alt='edit' width={24} /> */}
					{canDelete("rules") && (
						<img
							src={trashIcon}
							className="cursor-pointer"
							onClick={() => setDeleteModal(true)}
							alt="trash"
							width={24}
						/>
					)}
				</div>
			</td>
			{deleteModal && (
				<DeleteModal
					open={deleteModal}
					titleMsg={item?.name}
					deletedItem={item}
					modelService={roleService}
					onCloseModal={setDeleteModal}
					setShouldUpdate={setShouldUpdate}
				/>
			)}
		</tr>
	);
};
export default CardItem;
